// src/service-worker.js
/* eslint-env serviceworker */

import { precacheAndRoute } from 'workbox-precaching';

// This is the array of URLs to cache
const CACHE_NAME = 'my-pwa-cache-v1';
const urlsToCache = ['/', '/index.html'];

// Precache the files
precacheAndRoute(self.__WB_MANIFEST || []); // This will be replaced by Workbox during the build

// Install the service worker
self.addEventListener('install', (event) => {
  event.waitUntil(
    caches.open(CACHE_NAME).then((cache) => {
      console.log('Opened cache');
      return cache.addAll(urlsToCache);
    })
  );
});

// Fetch resources
self.addEventListener('fetch', (event) => {
  event.respondWith(
    caches.match(event.request).then((response) => {
      return response || fetch(event.request);
    })
  );
});

// Update the service worker
self.addEventListener('activate', (event) => {
  const cacheWhitelist = [CACHE_NAME];
  event.waitUntil(
    caches.keys().then((cacheNames) => {
      return Promise.all(
        cacheNames.map((cacheName) => {
          if (!cacheWhitelist.includes(cacheName)) {
            return caches.delete(cacheName);
          }
        })
      );
    })
  );
});